import { CaretDown, CaretUp, Clipboard } from '@phosphor-icons/react'
import * as Collapsible from '@radix-ui/react-collapsible'
import React from 'react'
import * as SideMenu from 'components/side-menu'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import { ArchivedCheckinsLink } from './archived-checkins-link'

export const CheckinsAccordion = () => {
  const localStorageKey = 'checkins-accordion-open'

  const [open, setOpen] = React.useState<boolean>(
    localStorage.getItem(localStorageKey) !== 'false'
  )

  const CaretIcon = open ? CaretUp : CaretDown

  const path = '/check-ins'
  const isActive = useIsActive(path, null, { exactMatch: true })

  return (
    <div className="relative">
      <Collapsible.Root
        open={open}
        onOpenChange={(nextOpen) => {
          setOpen(nextOpen)
          localStorage.setItem(localStorageKey, `${nextOpen}`)
        }}
      >
        <div className="flex gap-2">
          <SideMenu.LinkItem
            icon={Clipboard}
            active={isActive}
            analyticsProps={sideNavAnalyticsProps({
              title: 'Check-ins',
              href: path,
            })}
            href={path}
          >
            Check-ins
          </SideMenu.LinkItem>
          <Collapsible.Trigger className="absolute right-7 top-1 h-6 w-6 flex-grow-1 bg-transparent rounded flex items-center justify-center border-transparent hover:border-gray-100 border-px border-solid flex-shrink-0">
            <div className="px-1">
              <CaretIcon className="h-3 text-gray-400 w-3" weight="bold" />
            </div>
          </Collapsible.Trigger>
        </div>
        <Collapsible.Content className="border-0 border-gray-100 border-l border-solid ml-[18px] pl-[9px]">
          <ArchivedCheckinsLink />
        </Collapsible.Content>
      </Collapsible.Root>
    </div>
  )
}
